export default __webpack_public_path__ + "static/media/path-image.22ce24a8.svg";